import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const bookingPaths = new Set([
  '/procedures',
  '/emergency',
  '/practitioners',
  '/date-time-entry',
  '/appointment-summary',
  '/appointment-booked',
]);

const isExistingPatientFlow = (pathname: string) => {
  if (!localStorage.getItem('token')?.trim() || !localStorage.getItem('loginPatientId')?.trim()) return false;

  if ((pathname === '/date-time-entry' || pathname === '/appointment-summary')
    && localStorage.getItem('selectedAppointmentId')?.trim()) return true;

  try {
    const steps = JSON.parse(localStorage.getItem('headerDefinition') ?? 'null');
    return Array.isArray(steps) && steps.length === 5 && steps[3] === 'Zusammenfassung';
  } catch {
    return false;
  }
};

export function useBookingStepScrollReset() {
  const { pathname, key } = useLocation();
  const previousRestoration = useRef<History['scrollRestoration'] | null>(null);

  useLayoutEffect(() => {
    if (pathname !== '/move-conf' && (!bookingPaths.has(pathname) || !isExistingPatientFlow(pathname))) {
      if (previousRestoration.current !== null) {
        window.history.scrollRestoration = previousRestoration.current;
        previousRestoration.current = null;
      }
      return;
    }

    // Keep native history restoration from undoing the reset on Back/Forward.
    if (previousRestoration.current === null) {
      previousRestoration.current = window.history.scrollRestoration;
      window.history.scrollRestoration = 'manual';
    }

    // Instant also cancels smooth scrolling; older TS DOM types omit this value.
    const scrollOptions = { top: 0, left: 0, behavior: 'instant' as ScrollBehavior };
    // The current layout scrolls the document. Also reset any scrollable frame
    // containing the stepper, without touching inner calendar or time-slot lists.
    let frame = document.querySelector('.portal-booking-flow .booking-progress')?.parentElement;
    while (frame && frame !== document.scrollingElement) {
      if (/(auto|scroll)/.test(window.getComputedStyle(frame).overflowY) && frame.scrollHeight > frame.clientHeight) {
        frame.scrollTo(scrollOptions);
      }
      frame = frame.parentElement;
    }
    window.scrollTo(scrollOptions);
  }, [pathname, key]);

  useLayoutEffect(() => () => {
    if (previousRestoration.current !== null) {
      window.history.scrollRestoration = previousRestoration.current;
      previousRestoration.current = null;
    }
  }, []);
}
